import { ReactElement, RefObject, useRef, createRef } from 'react';
import { Button } from '@mui/material';
import { faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  compose as lcompose,
  map as lmap,
  find as lfind,
  getOr as lgetOr,
} from 'lodash/fp';

interface ILinkRef {
  link: string;
  ref: RefObject<HTMLAnchorElement>;
}

export const DownloadButton = ({
  links,
  onClick,
}: {
  links: string[];
  onClick: () => void;
}) => {
  const linkrefs = useRef<ILinkRef[]>([]);

  linkrefs.current = lmap<string, ILinkRef>(link => ({
    link,
    ref: createRef(),
  }))(links);

  return (
    <span>
      <Button
        onClick={lcompose(onClick, () =>
          lmap<ILinkRef, void>(({ ref }) => ref.current!.click())(
            linkrefs.current
          )
        )}
        variant="contained"
        color="primary">
        Download
        <FontAwesomeIcon icon={faFileDownload} size="1x" fixedWidth />
      </Button>

      {lmap<string, ReactElement>(link => (
        <a
          key={link}
          ref={lcompose(lgetOr(null, 'ref'), lfind({ link }))(linkrefs.current)}
          hidden
          href={`assets/${link}`}
          download={link}>
          link
        </a>
      ))(links)}
    </span>
  );
};
